export default {"src":"/_next/static/media/Dietatics.9d536c45.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};